(function () {
  const products = [
    {
      skuId: "FS-TW-2606-001",
      badge: "ONE OF ONE",
      titleEn: "Jinyu Mountain Green Phantom Quartz Necklace",
      titleCn: "锦鲤游山",
      primaryState: "Grounding",
      secondaryState: "Clarity",
      price: "$799",
      productType: "Necklace",
      necklaceForm: "Pendant",
      materials: "Green Phantom Quartz · Titanium Steel",
      sizeText: "Pendant 32 x 21 mm · Chain 45 cm",
      oneLineStory: "A quiet green landscape held inside clear quartz.",
      productStory: "A landscape-like inclusion sits inside the quartz, with green forms that feel held rather than staged. The Chinese name points to a small world of movement, water, and mountain light.",
      details: "Gem / main material: Green Phantom Quartz. Pendant dimensions: 32 x 21 mm. Chain length: 45 cm. Hardware: Titanium steel. SKU: FS-TW-2606-001.",
      certificate: "Certificate information will be shown here when included or available as an add-on. Natural inclusions, small color differences, and visible mineral patterns are part of the piece.",
      care: "Keep away from water, perfume, and hard impact. Store separately in its box when not worn.",
      relatedSkus: ["FS-MS-2606-002", "FS-WL-2606-003", "FS-NC-2606-005"]
    },
    {
      skuId: "FS-MS-2606-002",
      badge: "",
      titleEn: "Moonlit Tide Aquamarine Bracelet",
      titleCn: "海月浮光",
      primaryState: "Soothing",
      secondaryState: "Unfolding",
      price: "$399",
      productType: "Bracelet",
      materials: "Aquamarine · Moonstone · Titanium Steel",
      sizeText: "Beads 8-10 mm · Fits wrists 15-16 cm",
      sizeMode: "Selectable",
      oneLineStory: "Soft blue clarity with a moonlit glow.",
      productStory: "Aquamarine and moonstone create a cooler, quieter surface, selected for a softer rhythm and a sense of room to breathe.",
      details: "Materials: Aquamarine, Moonstone, Titanium steel. Bead size: 8-10 mm. Wrist fit: 15-16 cm. SKU: FS-MS-2606-002.",
      certificate: "Natural color, clouding, and surface variation may differ slightly from stone to stone.",
      care: "Avoid water, perfume, and impact. Store separately after wearing.",
      relatedSkus: ["FS-MS-2606-003", "FS-WL-2606-003", "FS-TW-2606-001"]
    },
    {
      skuId: "FS-MS-2606-003",
      badge: "",
      titleEn: "Moon Veil Moonstone Necklace",
      titleCn: "月幕微光",
      primaryState: "Soothing",
      secondaryState: "",
      price: "$549",
      productType: "Necklace",
      necklaceForm: "Pendant",
      materials: "Moonstone · Clear Quartz · Titanium Steel",
      sizeText: "Pendant 28 x 18 mm · Chain 45 cm",
      oneLineStory: "A pale veil of light, held close to the collarbone.",
      productStory: "This piece leans into a quieter glow: soft, translucent, and slightly dreamlike without becoming decorative noise.",
      details: "Materials: Moonstone, Clear Quartz, Titanium steel. Pendant dimensions: 28 x 18 mm. Chain length: 45 cm. SKU: FS-MS-2606-003.",
      certificate: "Natural glow and internal texture vary by stone.",
      care: "Keep dry and store separately from harder stones.",
      relatedSkus: ["FS-MS-2606-002", "FS-NC-2606-005", "FS-WL-2606-003"]
    },
    {
      skuId: "FS-WL-2606-003",
      badge: "",
      titleEn: "Pine Shadow Garden Quartz Bracelet",
      titleCn: "森影入石",
      primaryState: "Grounding",
      secondaryState: "Clarity",
      price: "$299",
      productType: "Bracelet",
      materials: "Garden Quartz · Agarwood · Titanium Steel",
      sizeText: "Beads 11-12 mm · Fits wrists 15-16 cm",
      sizeMode: "Selectable",
      oneLineStory: "Warm wood and green inclusions, steady without feeling heavy.",
      productStory: "Garden quartz and agarwood bring a grounded visual rhythm: organic, warm, and quietly structured.",
      details: "Materials: Garden Quartz, Agarwood, Titanium steel. Bead size: 11-12 mm. Wrist fit: 15-16 cm. SKU: FS-WL-2606-003.",
      certificate: "Natural inclusions and wood grain make each piece slightly different.",
      care: "Keep away from water and fragrance. Wipe gently after wear.",
      relatedSkus: ["FS-TW-2606-001", "FS-MS-2606-002", "FS-NC-2606-004"]
    },
    {
      skuId: "FS-NC-2606-004",
      badge: "OBJECT",
      titleEn: "Silver Sheen Obsidian Object",
      titleCn: "银曜星环",
      primaryState: "Protection",
      secondaryState: "",
      price: "Price on request",
      productType: "Object",
      materials: "Silver Sheen Obsidian",
      sizeText: "Object dimensions to be confirmed",
      oneLineStory: "A dark reflective piece with a quiet silver surface.",
      productStory: "This object is selected for its reflective surface and heavier presence. It is meant to be placed, looked at, and kept close rather than worn.",
      details: "Material: Silver Sheen Obsidian. Dimensions and weight will be confirmed before final listing. SKU: FS-NC-2606-004.",
      certificate: "Natural sheen, surface pattern, and polish may vary across angles.",
      care: "Place on a stable surface. Clean gently with a soft dry cloth.",
      relatedSkus: ["FS-NC-2606-005", "FS-WL-2606-003", "FS-TW-2606-001"]
    },
    {
      skuId: "FS-NC-2606-005",
      badge: "",
      titleEn: "Nocturne Spark Quartz Necklace",
      titleCn: "夜光微芒",
      primaryState: "Courage",
      secondaryState: "",
      price: "$149",
      productType: "Necklace",
      necklaceForm: "Pendant",
      materials: "Quartz · Titanium Steel",
      sizeText: "Pendant 24 x 16 mm · Chain 45 cm",
      oneLineStory: "A small flash of light for the next step.",
      productStory: "Clear quartz keeps the form simple, with a small bright center that feels direct rather than loud.",
      details: "Materials: Quartz, Titanium steel. Pendant dimensions: 24 x 16 mm. Chain length: 45 cm. SKU: FS-NC-2606-005.",
      certificate: "Natural clarity and internal texture may vary slightly.",
      care: "Avoid water, perfume, and hard impact. Store separately when not worn.",
      relatedSkus: ["FS-MS-2606-003", "FS-MS-2606-002", "FS-WL-2606-003"]
    }
  ];

  const bySku = new Map(products.map((product) => [product.skuId, product]));
  const SIZE_OPTIONS = {
    Bracelet: {
      label: "Wrist size",
      guideLabel: "Size guide",
      noteLine: "Need another size? Leave a note →",
      selectedPrefix: "Fits wrists",
      options: [
        { code: "S", text: "13–14 cm / 5.1–5.5 in" },
        { code: "M", text: "15–16 cm / 5.9–6.3 in" },
        { code: "L", text: "17–18 cm / 6.7–7.1 in" }
      ],
      guideTitle: "How to measure your wrist",
      guideBody: `
        <p>Wrap a soft measuring tape snugly around your wrist. Use your actual wrist measurement—do not add extra room.</p>
        <div class="product-size-guide-table">
          <span>S</span><span>13–14 cm / 5.1–5.5 in</span>
          <span>M</span><span>15–16 cm / 5.9–6.3 in</span>
          <span>L</span><span>17–18 cm / 6.7–7.1 in</span>
        </div>
        <p>If you are between sizes, choose the larger option.</p>
      `
    },
    BeadedNecklace: {
      label: "Necklace length",
      guideLabel: "Length guide",
      noteLine: "Need another size? Leave a note →",
      selectedPrefix: "",
      options: [
        { code: "S", text: "41 cm / 16 in" },
        { code: "M", text: "46 cm / 18 in" },
        { code: "L", text: "51 cm / 20 in" }
      ],
      guideTitle: "Necklace length guide",
      guideBody: `
        <div class="product-size-guide-list">
          <p><strong>S · 41 cm / 16 in</strong><span>Sits close to the base of the neck, around the collarbone.</span></p>
          <p><strong>M · 46 cm / 18 in</strong><span>The most versatile everyday length.</span></p>
          <p><strong>L · 51 cm / 20 in</strong><span>Sits lower on the chest and works well for layering.</span></p>
        </div>
      `
    }
  };

  function getSkuFromHref(href) {
    try {
      const url = new URL(href, window.location.href);
      return url.searchParams.get("sku") || url.pathname.split("/").filter(Boolean).pop()?.toUpperCase() || "";
    } catch (error) {
      return "";
    }
  }

  function stateLine(product) {
    return [product.primaryState, product.secondaryState].filter(Boolean).join(" · ");
  }

  function setText(root, selector, value) {
    const node = root.querySelector(selector);
    if (node && value) node.textContent = value;
  }

  function hydrateCard(card, product) {
    if (!product) return;
    const flag = card.querySelector(".product-flag");
    if (flag) {
      flag.textContent = product.badge || "";
      flag.hidden = !product.badge;
    }
    setText(card, ".product-card-title", product.titleEn);
    setText(card, ".product-card-state", stateLine(product));
    setText(card, ".product-card-price", product.price);
    card.dataset.sku = product.skuId;
    if (product.price && product.price.startsWith("$")) {
      card.dataset.price = product.price.replace(/[^0-9.]/g, "");
    }
    card.setAttribute("aria-label", `${product.titleEn}, ${product.price}`);
  }

  function hydrateCards() {
    document.querySelectorAll('a[href*="product.html?sku="], a[href^="/products/fs-"]').forEach((card) => {
      hydrateCard(card, bySku.get(getSkuFromHref(card.href)));
    });
  }

  // Shared across every product-card grid (home "Selected Pieces", Shop All,
  // PDP "More to Approach"): reserve title height per VISUAL ROW, sized to
  // that row's tallest title, not a hardcoded worst-case. Keeps state/price
  // aligned across a row without punishing single-line titles with dead
  // space when their row-mates are also single-line.
  function equalizeCardTitleRows(grid) {
    if (!grid) return;
    const titles = [...grid.querySelectorAll(".product-card-title")].filter(
      (title) => !title.closest("[hidden]")
    );
    if (!titles.length) return;
    titles.forEach((title) => { title.style.minHeight = ""; });
    const columns = getComputedStyle(grid).gridTemplateColumns.split(" ").length || 1;
    for (let i = 0; i < titles.length; i += columns) {
      const row = titles.slice(i, i + columns);
      const maxHeight = Math.max(...row.map((title) => title.getBoundingClientRect().height));
      row.forEach((title) => { title.style.minHeight = `${maxHeight}px`; });
    }
  }

  function equalizeAllCardGrids() {
    document
      .querySelectorAll(".f-pieces, .shop-product-grid, .product-related-grid")
      .forEach(equalizeCardTitleRows);
  }

  function setHtml(root, selector, html) {
    const node = root.querySelector(selector);
    if (node && html) node.innerHTML = html;
  }

  function renderDetails(summary, body) {
    return `<details><summary>${summary}</summary><div><p>${body}</p></div></details>`;
  }

  function sizeConfigFor(product) {
    if (product.sizeMode !== "Selectable") return null;
    if (product.productType === "Bracelet" || product.productType === "Bracelet_Double") {
      return SIZE_OPTIONS.Bracelet;
    }
    if (product.productType === "Necklace" && product.necklaceForm === "Beaded") {
      return SIZE_OPTIONS.BeadedNecklace;
    }
    return null;
  }

  function selectedSizeText(config, code) {
    const option = config.options.find((item) => item.code === code) || config.options[1];
    const body = config.selectedPrefix ? `${config.selectedPrefix} ${option.text}` : option.text;
    return `${option.code} · ${body}`;
  }

  function renderSizeSelector(product) {
    const container = document.querySelector(".product-size-selector");
    if (!container) return;
    const config = sizeConfigFor(product);
    if (!config) {
      container.hidden = true;
      container.innerHTML = "";
      return;
    }
    container.hidden = false;
    container.innerHTML = `
      <div class="product-size-head">
        <span>${config.label}</span>
        <button type="button" class="product-size-guide-toggle" aria-expanded="false">${config.guideLabel}</button>
      </div>
      <div class="product-size-options" role="radiogroup" aria-label="${config.label}">
        ${config.options.map((option) => `
          <button type="button" class="product-size-option${option.code === "M" ? " is-selected" : ""}" role="radio" aria-checked="${option.code === "M"}" data-size-code="${option.code}">${option.code}</button>
        `).join("")}
      </div>
      <p class="product-size-current">${selectedSizeText(config, "M")}</p>
      <div class="product-size-guide" hidden>
        <h3>${config.guideTitle}</h3>
        ${config.guideBody}
      </div>
      <button type="button" class="product-size-note-toggle" aria-expanded="false">${config.noteLine}</button>
      <div class="product-size-note" hidden>
        <label for="product-size-note">Size note · Optional</label>
        <p>Tell us your exact wrist measurement or preferred necklace length.</p>
        <textarea id="product-size-note" rows="3" placeholder="Enter your size request here..."></textarea>
        <p>We’ll follow up if anything needs confirming.</p>
      </div>
    `;

    const current = container.querySelector(".product-size-current");
    const optionButtons = [...container.querySelectorAll(".product-size-option")];
    optionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        optionButtons.forEach((item) => {
          item.classList.toggle("is-selected", item === button);
          item.setAttribute("aria-checked", String(item === button));
        });
        current.textContent = selectedSizeText(config, button.dataset.sizeCode);
        container.dataset.selectedSize = button.dataset.sizeCode;
      });
    });

    const guide = container.querySelector(".product-size-guide");
    const guideToggle = container.querySelector(".product-size-guide-toggle");
    guideToggle.addEventListener("click", () => {
      guide.hidden = !guide.hidden;
      guideToggle.setAttribute("aria-expanded", String(!guide.hidden));
    });

    const note = container.querySelector(".product-size-note");
    const noteToggle = container.querySelector(".product-size-note-toggle");
    noteToggle.addEventListener("click", () => {
      note.hidden = !note.hidden;
      noteToggle.setAttribute("aria-expanded", String(!note.hidden));
    });

    container.dataset.selectedSize = "M";
  }

  function renderRelated(product) {
    const grid = document.querySelector(".product-related-grid");
    if (!grid || !product.relatedSkus) return;
    grid.innerHTML = product.relatedSkus.map((sku) => {
      const related = bySku.get(sku);
      if (!related) return "";
      const flag = related.badge ? `<span class="product-flag">${related.badge}</span>` : "";
      return `
        <a class="shop-product-card" href="/products/${related.skuId.toLowerCase()}">
          <div class="imgslot">${flag}<span class="tag">Image slot · related · 1:1</span></div>
          <div class="product-card-copy">
            <h3 class="product-card-title">${related.titleEn}</h3>
            <p class="product-card-state">${stateLine(related)}</p>
            <p class="product-card-price">${related.price}</p>
          </div>
        </a>
      `;
    }).join("");
  }

  function hydrateProductPage() {
    const productInfo = document.querySelector(".product-info");
    if (!productInfo) return;
    const params = new URLSearchParams(window.location.search);
    const product = bySku.get(params.get("sku")) || products[0];
    document.title = `${product.titleEn} | Frequency & Stone`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", `${product.titleEn} from Frequency & Stone. ${product.oneLineStory}`);
    setText(document, ".product-crumb span:last-child", product.titleEn);
    const badge = productInfo.querySelector(".product-badge");
    if (badge) {
      badge.textContent = product.badge || "";
      badge.hidden = !product.badge;
    }
    setText(productInfo, "h1", product.titleEn);
    setText(productInfo, ".product-cn", product.titleCn);
    setText(productInfo, ".product-state-line", stateLine(product));
    setHtml(productInfo, ".product-one-line", `${product.oneLineStory} <a href="#about-this-piece">Read more</a>`);
    setText(productInfo, ".product-price", product.price);
    const facts = productInfo.querySelectorAll(".product-quick-facts strong");
    if (facts[0]) facts[0].textContent = product.materials;
    if (facts[1]) facts[1].textContent = product.sizeText;
    const cta = productInfo.querySelector(".product-cta");
    if (cta) cta.textContent = product.productType === "Object" ? "ENQUIRE ABOUT THIS PIECE" : `ADD TO BAG · ${product.price}`;
    renderSizeSelector(product);
    const accordions = productInfo.querySelector(".product-accordions");
    if (accordions) {
      accordions.innerHTML = `
        <details open><summary>About this piece</summary><div><p id="about-this-piece">${product.productStory}</p></div></details>
        ${renderDetails("Details & dimensions", product.details)}
        ${renderDetails("Certificate & natural variation", product.certificate)}
        ${renderDetails("Shipping & returns", "Ships in 2-4 business days. Complimentary worldwide shipping over $129. One-of-one pieces are packed gift-ready and should be returned in their original condition.")}
        ${renderDetails("Care", product.care)}
      `;
    }
    renderRelated(product);
    hydrateCards();
  }

  window.FSProducts = { all: products, bySku };
  // Exposed so shop.html can re-run it precisely after its own filter/sort
  // DOM mutations, without waiting for the generic resize-driven pass below.
  window.FSEqualizeCardTitleRows = equalizeCardTitleRows;

  hydrateCards();
  hydrateProductPage();
  equalizeAllCardGrids();

  let equalizeResizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(equalizeResizeTimer);
    equalizeResizeTimer = setTimeout(equalizeAllCardGrids, 150);
  });
})();
